import React from 'react'
import {Route, Switch} from 'react-router-dom'
import NotFound from './components/NotFound'
/*import Login from './containers/Login'
import Account from './containers/Account'*/
/*import ForgotPassword from './containers/Login/Unblock/forgotPassword'
import AccessRestoring from './containers/Login/Unblock/accessRestoring'
import Profile from './containers/Profile'
import ConfirmEmail from './containers/Profile/Email/Confirm'*/
import Register from "./containers/Register";


const Routes = () => {
    return (
        <Switch>
            {/*<Route
                path='/about'
                component={About}
                exact
            />*/}
            <Route
                path='/register'
                component={Register}
                exact
            />
            {/*<Route
                   path='/'
                   component={Home}
                   exact
            />*/}
            <Route path='*'
                   component={NotFound}
                   exact
            />
        </Switch>
    )
}

export default Routes
